// extracted by mini-css-extract-plugin
export default {"regular":"400","semiBold":"600","bold":"700"};